import React from "react";
import {
    Layout,
    message,
    Form,
    Row,
    Col,
    Switch
} from "antd";
import MiCompAPI from "./../../util/api";
import TableWrapper from '../elements/TableWrapper';
const { Content } = Layout;
class FD extends React.Component {
    settings_columns = [
        {
            title: 'Settings Description',
            dataIndex: 'settingsKeyDesc',
            sorter: (a, b) => a.settingsKeyDesc.localeCompare(b.settingsKeyDesc),
            sortDirections: ["descend", "ascend"]
        },
        {
            title: "Allow",
            dataIndex: "settingsValueBit",
            width: 180,
            render: (text, record) => {
                return (
                    <div style={{ display: 'flex' }}>
                        <Switch defaultChecked={record["settingsValueBit"]} style={{ marginRight: '10px' }} onChange={() => this.ChangeStatusById(record, text)} />
                    </div>
                );
            },
        },
    ];
    constructor(props) {
        super(props);
        this.state = {
            settings: null,
            masterSettings: null,
            loadSettings: true
        };
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    ChangeStatusById = (record, value) => {
        for (var i = 0; i < this.state.masterSettings.length; i++) {
            if (this.state.masterSettings[i].id === record.id) {
                var mSettings = this.state.masterSettings;
                mSettings[i].settingsValueBit = !value;
                this.setState({ masterSettings: mSettings });
            }
        }
        var data = [record];
        this.api.invoke("SaveandUpdateMasterSettings", "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        message.destroy();
                        message.success(data.statusMessage, 3);
                    }
                    else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                    this.getMasterSettings();
                }
            }, data);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.api.invoke(
                    "SaveandUpdateAdminSettings",
                    "post",
                    (data, success) => {
                        if (success) {
                            if (data.statusCode === 200) {
                                message.destroy();
                                message.success(data.statusMessage, 3);
                                this.getSettings()
                            } else {
                                message.destroy();
                                message.success(data.statusMessage, 3);
                            }
                        } else {
                            message.destroy();
                            message.success(data.statusMessage, 3);
                        }
                    },
                    { ...values, id: this.state.settings ? this.state.settings.id : 0 }
                );
            }
        });
    }
    componentDidMount = () => {
        this.getSettings();
        this.getMasterSettings();
    }


    getSettings() {
        const { setFieldsValue } = this.props.form;
        this.api.invoke(
            "GetAdminSettings",
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({ settings: data.data });
                        if (data.data != null) {
                            setFieldsValue({
                                inboundpath: data.data.inboundpath,
                                outboundpath: data.data.outboundpath,
                            });
                        }
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            }
        );
    }
    getMasterSettings() {
        this.setState({ loadSettings: true });
        this.api.invoke(
            "GetMasterSettings",
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({ masterSettings: data.data, loadSettings: false });
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            }
        );
    }
    render() {
        return (
            <Content>
                <div className="mi_main_div">
                    <div className="mi_main" style={{ marginTop: "10px" }}>
                        <Row>
                            <Col md={6} sm={24}></Col>
                            <Col md={12} sm={24}>
                                {/* <p className='mi_title'>Settings</p> */}
                                <TableWrapper title="Settings" rowkey="id" columns={this.settings_columns} data={this.state.loadSettings ? null : this.state.masterSettings} loading={this.state.loadSettings} />
                            </Col>
                            <Col md={6} sm={24}></Col>
                        </Row>

                    </div>
                </div>
            </Content>
        );
    }
}
const Settings = Form.create()(FD);
export default Settings;